import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["topNav", "header"];

  connect() {
    console.log("NavbarController connected");
    this.handleScroll = this.handleScroll.bind(this); // Bind the method to the controller instance
    document.addEventListener("scroll", this.handleScroll);
  }

  disconnect() {
    document.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    if (!this.hasHeaderTarget) {
      console.warn("Header target is missing");
      return;
    }

    const scrollPosition = window.scrollY;
    const headerHeight = this.headerTarget.offsetHeight;

    if (scrollPosition > headerHeight) {
      this.topNavTarget.style.opacity = Math.max(1 - (scrollPosition - headerHeight) / 80, 0);
    } else {
      this.topNavTarget.style.opacity = 1;
    }
  }
}
